import { render, staticRenderFns } from "./PrintOnly.vue?vue&type=template&id=4579f3e1&scoped=true&lang=true&"
var script = {}
import style0 from "./PrintOnly.vue?vue&type=style&index=0&id=4579f3e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4579f3e1",
  null
  
)

export default component.exports